import { render } from "./preset.vue?vue&type=template&id=54a07f64&scoped=true&lang=pug"
import script from "./preset.vue?vue&type=script&lang=js"
export * from "./preset.vue?vue&type=script&lang=js"

import "./preset.vue?vue&type=style&index=0&id=54a07f64&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54a07f64"]])

export default __exports__